import { useState } from "react";
import StaffListPopup from "./StaffListPopup";

const StaffPreview = ({ staffs, visibleStaffs, remaining }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex flex-wrap gap-1">
        {visibleStaffs.map((s) => (
          <span
            key={s.id}
            title={s.fullName}
            className="
              px-2 py-1 
              bg-blue-100 text-blue-700 
              text-xs rounded-full
              max-w-[120px]
              truncate
              inline-block
              whitespace-nowrap
            "
          >
            {s.fullName}
          </span>
        ))}

        {remaining > 0 && (
          <button
            onClick={() => setOpen(true)}
            className="
              px-2 py-1 
              bg-gray-200 text-gray-700 
              text-xs rounded-full
              hover:bg-gray-300
            "
          >
            +{remaining}
          </button>
        )}
      </div>

      {open && (
        <StaffListPopup staffs={staffs} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default StaffPreview;
